export default __webpack_public_path__ + "static/media/input-loading.925b891b.svg";